import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UserData } from '../../models/user';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Items } from '../../providers/providers';
import { User } from '../../providers/user';
import { UserAccount } from '../../models/account';
//import {Paypal} from '../../providers/paypal'
import { NavController, ToastController, AlertController, ModalController, LoadingController } from 'ionic-angular';
import { AddUserPage } from '../../pages/add-user/add-user';
import { Practice } from '../../models/practice';
import { Template } from '../../models/template';
import { Grouping } from '../../models/groupings';
/**
 * Generated class for the UpgradePlanComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'upgrade-plan',
  templateUrl: 'upgrade-plan.html'
})
export class UpgradePlanComponent {

  @Input() text: string;
  @Input() practice: any;
  // @Input() accountData: UserAccount;
  @Output() makeAccountPayment: EventEmitter<UserAccount> = new EventEmitter<UserAccount>();
  @Output() usersTabSelected: EventEmitter<Practice> = new EventEmitter<Practice>();//usersTabSelected method is mapped in account.ts and will be called if something changes here
  userData: UserData;
  isReadyToSave: boolean;
  isReadyToSend: boolean;
  isMasterUser: boolean;
  isReadyToUpdate: boolean;
  isReadyToUpdateRef: boolean;
  accountData: UserAccount;
  emailTemplates: Template[]// = new Array(5)
  filteredEmailTemplates: Template[]// = new Array(5)
  // emailTemplates: Template
  userRole: any[];
  plan: string;
  maxClients: string;
  maxAssessments: string;
  clientCount: number;
  monthlyAssessments: string;
  users: any[];
  groupings: any[];
  selectedGroup: Grouping;
  showClient: boolean;
  groupClients: any[];
  userType: string;
  practiceName: string;
  practiceId: string;
  practiceData: Practice;
  radioSelected: any;
  showUserGroup: boolean = false;
  updatingToPref: boolean;
  two_factor: boolean = false;
  updatingTwoFactor: boolean = false;
  enum_details = [
    { name: 'Supervisor', id: '2' },
    { name: 'Practitioner', id: '3' },
  ]

  public form: FormGroup
  public form1: FormGroup
  public form2: FormGroup
  public form3: FormGroup
  public form4: FormGroup
  public form5: FormGroup

  constructor(public formBuilder: FormBuilder, public items: Items, public alertCtrl: AlertController, public toastCtrl: ToastController, public user: User,
    public navCtrl: NavController, public modalCtrl: ModalController, public loading: LoadingController) {
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    if (this.userData.usertype_id === "1") {
      this.isMasterUser = true;
    }
    this.showClient = false;
    this.userType = "2";
    this.practiceData = <Practice>JSON.parse(localStorage.getItem('practiceData'));
    if (this.practiceData) {
      this.practiceName = this.practiceData.name;
      var userId = this.userData.id;
      console.log('user' + userId);
      //this.users = this.practiceData.users.filter(function (el) { return el.usertype_id != '1'; });
    }

    this.refreshRole();

    this.getGroupings();
    this.getUsers();

    this.items.getAccountDetails().subscribe(res => {
      if (res) {
        this.accountData = res;
        localStorage.setItem('accountData', JSON.stringify(res));
        this.plan = this.accountData.chargebee_plan;
        this.maxClients = this.accountData.max_clients;
        this.maxAssessments = this.accountData.max_assessments;
        this.clientCount = this.accountData.client_count;
        this.monthlyAssessments = this.accountData.monthly_administered_assessments;
      }
    }, err => {
      console.error('ERROR', err);
    });
    this.items.getEmailTemplates().subscribe(res => {
      if (res) {
        this.emailTemplates = res;
        this.filteredEmailTemplates = this.emailTemplates.filter(function (e) {
          return e.title != "";
      });
        // this.emailTemplates[0] = {title: "Email Template 1", subject: "Novopsych", body: 'Dear FIRST NAME, '
        // + 'This is an automated email setup by CLINICIAN TITLE FIRST NAME LAST NAME  who would like you to fill in a questionnaire to check in with you.'
        // + 'Please click the link below and follow the prompts to fill in the assessment. The results will be available to clinician  once you have submitted the assessment.Thank you.', default: true}
      }
    }, err => {
      console.error('ERROR', err);
    });
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.form = this.formBuilder.group({
      first_name: [this.userData.first_name, Validators.required],
      last_name: [this.userData.last_name, Validators.required],
      email: [this.userData.email, Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      title_id: [this.userData.title_id, Validators.required],
      profession_id: [this.userData.profession_id, Validators.required]
    });

    this.two_factor =(this.userData.two_auth == '1' ? true : false)

    // Watch the form for changes, and
    this.form.valueChanges.map((val) => {
      // remove the trailing spaces from first name and last name
      val.first_name = val.first_name.trim();
      val.last_name = val.last_name.trim();
      return val;
    })
      .subscribe((val) => {
        this.isReadyToSave = this.form.valid;
      });

    //Form2 to send feedback
    this.form1 = this.formBuilder.group({
      body: [, Validators.required],
      feedback_type_id: ['1',]
    });

    this.form1.valueChanges.subscribe((v) => {
      this.isReadyToSend = this.form1.valid;
    });

    //Form2 to send feedback
    this.form2 = this.formBuilder.group({
      send_to_administer: [this.userData.send_to_administer == 1 ? true : false],
      send_to_practitioner: [this.userData.send_to_practitioner == 1 ? true : false],
      response_pdf: [this.userData.response_pdf],
      forward_email: [this.userData.forward_email, Validators.compose([Validators.pattern(EMAIL_REGEXP)])]
    });    
  
    this.form2.valueChanges.subscribe((v) => {
      this.isReadyToUpdateRef = this.form2.valid;
    });

    //form3 to modify userType
    this.form3 = this.formBuilder.group({
      usertype_id: ['2']
    });

    this.form4 = this.formBuilder.group({
      name: [this.practiceName, Validators.required]
    });
    this.form4.valueChanges.subscribe((v) => {
      this.isReadyToUpdate = this.form4.valid;
    });

  }

  public trackById (index, user) {
    return user.id;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'practice') {
        let practice = changes['practice'].currentValue;
        if (typeof practice === 'undefined') {
          //do nothing
        } else {
          var userId = this.userData.id;
          console.log('user' + userId);
          //this.users = this.practice.users.filter(function (el) { return el.usertype_id != '1' && el.id != userId; });
          console.log('watcher');
          //console.log(this.users);
        }

      }

    }

  }

  refreshRole() {
    this.userRole = new Array<any>();
    if (this.users) {
      for (let i = 0; i < this.users.length; i++) {
        console.log(this.users[i].usertype_id);
        this.userRole.push(parseInt(this.users[i].usertype_id));
      }
    }
  }

  selectGroup(group, clients) {
      this.selectedGroup = group;
      this.groupClients = clients;
      this.showClient = true;
  }

  deselectGroup(group) {
      this.showClient = false;
  }

  getUsers() {
    this.items.getUsers().subscribe(res => {
      console.log(res);
      console.log('test');
      if (res) {
        this.users = res;
      }
    },
      err => {
        console.log(err);
      });
  }

  updateGrouping(id, value) {
    var data = {
      'user_id': id,
      'groups': value
    };
    let loading = this.loading.create({ spinner: 'hide', content: `<img src="assets/images/Loading.gif" />`, duration: 5000, cssClass: 'activity-detail-loading', showBackdrop: false, dismissOnPageChange: true });
    loading.present();
    this.items.assignGrouping(data).subscribe((resp) => {
      if (resp) {
        loading.dismissAll();
        this.presentToast("Selected user's group setting updated");
      }
    }, (err) => {
      loading.dismissAll();
      this.presentToast("Fail to update selected user's group setting");
    })
  }

  getGroupings() {
    this.items.getGroupings().subscribe(res => {
      if (res) {
        this.groupings = res;

        if (this.groupings.length > 0) {
          this.showUserGroup = true;
        } else {
          this.showUserGroup = false;
        }
      }
    },
      err => {
        console.log(err);
      });
  }

  addGrouping() {
    let prompt = this.alertCtrl.create({
      title: 'Client Group',
      message: "Create new client group",
      inputs: [
        {
          name: 'groupName',
          placeholder: 'Enter group name'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {

          }
        },
        {
          text: 'OK',
          handler: data => {
            if (data.groupName.trim == '') {
              this.presentToast("Please insert the new client group name")
            } else {
              let grouping = new Grouping(data.groupName);
              this.items.addGrouping(grouping).subscribe((resp) => {
                this.presentToast("Group successfully created");
                this.getGroupings();
              }, (err) => {
                this.presentToast("Error creating group");
              })
            }
          }
        }
      ]
    });
    prompt.present();
  }

  editGrouping(group) {
    let prompt = this.alertCtrl.create({
      title: 'Client Group',
      message: "Edit client group",
      inputs: [
        {
          name: 'groupName',
          placeholder: 'Enter group name',
          value: group.name
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {

          }
        },
        {
          text: 'OK',
          handler: data => {
            if (data.groupName.trim == '') {
              this.presentToast("Please insert the new group name")
            } else {
              let grouping = new Grouping(data.groupName);
              this.items.editGrouping(grouping, group.id).subscribe((resp) => {
                this.presentToast("Group successfully created");
                this.getGroupings();
              }, (err) => {
                this.presentToast("Error creating group");
              })
            }
          }
        }
      ]
    });
    prompt.present();
  }

  deleteGrouping(id) {
    let prompt = this.alertCtrl.create({
      message: "Are you sure you want to delete this client group?",
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Yes',
          handler: data => {
            this.items.deleteGrouping(id).subscribe((resp) => {
              if (resp) {
                this.presentToast("Group successfully removed");
                this.getGroupings();
              }
            }, (err) => {

            })

          }
        }
      ]
    });
    prompt.present();
  }

  deleteClientGrouping(id) {
    let prompt = this.alertCtrl.create({
      message: "Are you sure you want to remove this client from group?",
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Yes',
          handler: data => {
            this.items.deleteClientGrouping(this.selectedGroup, id).subscribe((resp) => {
              if (resp) {
                console.log(resp.grouping);
                this.presentToast("Client successfully removed from group");
                this.groupClients = resp.grouping.Client;
                this.getGroupings();
              }
            }, (err) => {

            })

          }
        }
      ]
    });
    prompt.present();
  }

  addClientGrouping(clients) {
    let modal = this.modalCtrl.create('ClientGroupingPage', { clients: clients, group: this.selectedGroup });
    modal.onDidDismiss(data => {
      console.log(data);
      this.groupClients = data;
      this.getGroupings();
    });
    modal.present();
  }

  addUser() {
    this.items.getAccountDetails().subscribe(res => {
      if (res) {
        this.accountData = res;
        if (this.accountData.usertype_id == "1" || this.accountData.usertype_id == "2") {
          let addModal = this.modalCtrl.create(AddUserPage, null, { cssClass: "add-user-modal" });
            addModal.onDidDismiss(item => {
              if (item) {
                if (item.dismiss === 'done') {
                  this.items.addUser(item.form).subscribe(res => {
                    if (res) {
                      let modal = this.modalCtrl.create('AlertPage', { text: this.createAlertText(item.form.email), screen: 'account' });
                      modal.present();
                    }
                  }, err => {
                    console.error('ERROR', err);
                  });

                }
              }
          })
          addModal.present();
        }
        // else {
        //   this.presentAlert();
        // }
      }
    }, err => {
      console.error('ERROR', err);
    });

  }

  radioChecked(item1: any, item2: any) {
    console.log(this.userData);
    console.log(item1);
    console.log(item2);
    // this.items.updateUserRole(item).subscribe(res =>{
    //   if(res){
    //     console.log("practice deleted")
    //   }
    // },
    // err => {
    //   console.error('ERROR', err);
    // });
  }

  deleteUser(id) {
    let prompt = this.alertCtrl.create({
      message: "Are you sure you want to delete this user? Clients of the user will still be available to other users within the practice.",
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Yes',
          handler: data => {
            this.items.deleteUser(id).subscribe((resp) => {
              if (resp) {
                let index = this.users.findIndex(result => result.id === id);
                if (index > -1) {
                  this.users.splice(index, 1);
                }
                
              this.user.getPractices().subscribe(res => {
                if(res){
                  localStorage.setItem('practiceData', JSON.stringify(res));
                  this.practiceData = <Practice>JSON.parse(localStorage.getItem('practiceData'));
                  var userId = this.userData.id;
                  //this.users = this.practiceData.users.filter(function (el) { return el.usertype_id != '1' && el.id != userId; });
                  this.refreshRole();
                  this.getUsers();
                }
                this.presentToast("User removed from practice");
              });
              }
            }, (err) => {

            })

          }
        }
      ]
    });
    prompt.present();
  }

  userRoleChange(id: any, role: any) {
    //console.log(index);
    let loading = this.loading.create({ spinner: 'hide', content: `<img src="assets/images/Loading.gif" />`, duration: 5000, cssClass: 'activity-detail-loading', showBackdrop: false, dismissOnPageChange: true });
    loading.present();
    let item = {
      usertype_id: role
    }
    let seq = this.items.updateUserRole(item, id).share();
    seq
      .map(res => res.json().data)
      .subscribe(res => {
        if (res) {
          //this.userRole[index] = role;
          this.user.getPractices().subscribe(res => {
            if(res){
              localStorage.setItem('practiceData', JSON.stringify(res));
              this.practiceData = <Practice>JSON.parse(JSON.stringify(res));
              var userId = this.userData.id;
              //this.users = this.practiceData.users.filter(function (el) { return el.usertype_id != '1' && el.id != userId; });
              //console.log(this.users);
              this.refreshRole();
              this.getUsers();
            }
            loading.dismissAll();
            this.presentToast("User information successfully saved");
          },
            err => {
              console.error('ERROR', err);
            });
        }

      }, err => {
        loading.dismissAll();
        this.presentToast("Fail to update user role");
        console.error('ERROR', err);
      });

    // this.items.updateUserRole(item).subscribe(res =>{
    //   if(res){
    //     console.log("practice deleted")
    //   }
    // },
    // err => {
    //   console.error('ERROR', err);
    // });
  }


  createAlertText(email: string) {
    var string = "An email invite has been sent to "
    return string + email;
  }

  updateSecurity() {
    let loading = this.loading.create({ spinner: 'hide', content: `<img src="assets/images/Loading.gif" />`, duration: 5000, cssClass: 'activity-detail-loading', showBackdrop: false, dismissOnPageChange: true });
    this.updatingTwoFactor = true
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    let seq = this.user.changeSecurity(this.two_factor, this.userData.id).share();
    seq
      .map(res => res.json().data)
      .subscribe(res => {
        localStorage.setItem('userData', JSON.stringify(res.user));
        this.presentToast("Your security preference is changed");
        this.updatingTwoFactor = false;
        loading.dismiss()
      }, err => {
        console.error('ERROR', err);
        this.updatingTwoFactor = false;
        loading.dismiss()
      });
  }

  updateUser() {
    if (!this.form.valid) { return; }
    console.log(this.form.value);
    let seq = this.items.updateUser(this.form.value, this.userData.id).share();
    seq
      .map(res => res.json().data)
      .subscribe(res => {
        if (res) {
          console.log('update userId' + res.user.email);
          localStorage.setItem('userData', JSON.stringify(res.user));
          localStorage.setItem('userId', res.user .email);
          this.presentToast("User information successfully saved");
        }

      }, err => {
        this.presentToast("Cannot update, this email already exists");
        this.form.get('email').setValue(localStorage.getItem('userId'));
        console.error('ERROR', err);
      });

  }

  changePreference() {
    if (!this.form2.valid) { return; }
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    let seq = this.user.changePreference(this.form2.value, this.userData.id).share();
    seq
      .map(res => res.json().data)
      .subscribe(res => {
        localStorage.setItem('userData', JSON.stringify(res.user));
        // this.userData.response_csv = this.form2.value.response_csv
        // this.userData.response_pdf = this.form2.value.response_pdf
        this.presentToast("Your email preference is changed");
      }, err => {
        console.error('ERROR', err);
      });
  }

  changePracticeName() {
    if (!this.form4.valid) { return; }
    let seq = this.items.updatPracticeName(this.form4.value, this.practiceData.id).share();
    seq
      .map(res => res.json().data)
      .subscribe(res => {
      }, err => {
        console.error('ERROR', err);
      });
  }

  sendFeedback() {
    let feedback: any;
    if (!this.form1.valid) { return; }
    feedback = { body: this.form1.value.body, user_id: this.userData.id, feedback_type_id: this.form1.value.feedback_type_id };
    this.user.sendFeedback(feedback).subscribe((resp) => {
      this.presentToast("Thanks for sharing your feedback");
    }, (err) => {
      this.presentToast("There was a problem sending your feedback");
    })
  }

  sendEmail() {
    window.open("mailto:info@novopsych.com?Subject=Practice Plan", '_system');
  }

  openPricing() {
    window.open("https://novopsych.com/pricing/", "_blank", "location=true");
  }

  changePassword() {
    let prompt = this.alertCtrl.create({
      title: 'Change Password?',
      message: "Please enter your current and new password",
      inputs: [
        {
          name: 'currentPassword',
          placeholder: 'Current Password'
        },
        {
          name: 'newPassword',
          placeholder: 'New Password',
          type: 'password'
        },
        {
          name: 'confirmPassword',
          placeholder: 'Confirm Password',
          type: 'password'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {

          }
        },
        {
          text: 'OK',
          handler: data => {
            if (data.newPassword != data.confirmPassword) {
              this.presentToast("The new password fields do not match, please try again")
            }
            let password = localStorage.getItem('password');
            if (data.currentPassword != password) {
              this.presentToast("please check your current password and try again")
            } else {
              this.user.changePassword(data.currentPassword, data.newPassword, data.confirmPassword).subscribe((resp) => {
                this.presentToast("Your password has been changed");
                localStorage.setItem('password', data.newPassword);
              }, (err) => {
                this.presentToast("The current password is not correct");
              })
            }
          }
        }
      ]
    });
    prompt.present();
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  makePayment(amount: string, plan: string) {
    this.makeAccountPayment.emit(this.accountData);

  }

  updatePayment() {
    this.makeAccountPayment.emit(this.accountData);
  }

  presentTemplateAlert() {
    let alert = this.alertCtrl.create({
      message: 'Only five templates can be saved, to create a new template please delete or edit an existing one',
      buttons: [
        {
          text: 'OK',
          handler: data => {
          }
        }
      ]
    });
    alert.present();
  }

  createTemplate() {
    if (this.filteredEmailTemplates.length > 4) {
      this.presentTemplateAlert()
    }
    else {
      let modal = this.modalCtrl.create('EmailTemplatePage');
      modal.onDidDismiss(item => {
        if (item) {
          if(item.template.default == true){
            for (let j = 0; j < this.emailTemplates.length; j++){
              if (this.emailTemplates[j].default == true){
                this.emailTemplates[j].default = false
              }
            }
          }
          for (let i = 0; i < this.emailTemplates.length; i++) {
            if (this.emailTemplates[i].title === "") {
              this.emailTemplates[i].title = item.template.title;
              this.emailTemplates[i].subject = item.template.subject;
              this.emailTemplates[i].body = item.template.body;
              this.emailTemplates[i].default = item.template.default;
              break
            }

        }

          let seq = this.items.createEmailTemplate(this.emailTemplates).share();
          seq
            .map(res => res.json().data.templates)
            .subscribe(res => {
              this.emailTemplates = res;
              this.filteredEmailTemplates = this.emailTemplates.filter(function (e) {
                return e.title != "";
              });
            }, err => {
              console.error('ERROR', err);
            });
        }
      })
      modal.present();
    }
  }

  editTemplate(template, indexValue) {
    let modal = this.modalCtrl.create('EmailTemplatePage', { template: template });
    modal.onDidDismiss(item => {
      if (item) {
        if (item.dismiss === 'done') {
          if(item.template.default == true){
            for (let j = 0; j < this.emailTemplates.length; j++){
              if (this.emailTemplates[j].default == true){
                this.emailTemplates[j].default = false
              }
            }
          }
          this.emailTemplates[indexValue].title = item.template.title;
          this.emailTemplates[indexValue].subject = item.template.subject;
          this.emailTemplates[indexValue].body = item.template.body;
          this.emailTemplates[indexValue].default = item.template.default;

          let seq = this.items.createEmailTemplate(this.emailTemplates).share();
          seq
            .map(res => res.json().data.templates)
            .subscribe(res => {
              this.emailTemplates = res;
              this.filteredEmailTemplates = this.emailTemplates.filter(function (e) {
              return e.title != "";
          });
            }, err => {
              console.error('ERROR', err);
            });
        }
        else {
          if (item.dismiss === 'delete') {
            this.emailTemplates[indexValue].title = "";
            this.emailTemplates[indexValue].subject = "";
            this.emailTemplates[indexValue].body = "";
            this.emailTemplates[indexValue].default = false;
  
            let seq = this.items.createEmailTemplate(this.emailTemplates).share();
            seq
              .map(res => res.json().data.templates)
              .subscribe(res => {
                this.emailTemplates = res;
                this.filteredEmailTemplates = this.emailTemplates.filter(function (e) {
                return e.title != "";
          });
              }, err => {
                console.error('ERROR', err);
              });
          }
        }
      }
    })
    modal.present();
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      message: 'To add users please upgrade to the Practice Plan',
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Change Plan',
          handler: data => {

            this.usersTabSelected.emit();
          }
        }
      ]
    });
    alert.present();
  }

  openUserGuide() {
    window.open("https://novopsych.com/user_guide/", "_blank");
  }

  openFAQ() {
    window.open("https://novopsych.com/faq/", "_blank");
  }

  openTerms() {
    window.open("https://novopsych.com/terms-conditions-privacy/", "_blank");
  }

  openWebsite() {
    window.open("https://novopsych.com/", "_blank")
  }

}



// WEBPACK FOOTER //
// ./src/components/upgrade-plan/upgrade-plan.ts